import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button } from '@jotpsych/ui/mui';

import type { IntakeReminderVariant } from './intakeReminder';

const COPY: Record<IntakeReminderVariant, { message: string; action: string }> = {
  start: {
    message: 'Your practice is waiting on your intake. Start it so we can finish setting you up.',
    action: 'Start intake',
  },
  finish: {
    message: 'Your intake is not submitted yet. Pick up where you left off and submit it.',
    action: 'Finish intake',
  },
};

export function IntakeReminderBanner({
  variant,
  to,
  onActionClick,
}: {
  variant: IntakeReminderVariant;
  to: string;
  onActionClick?: () => void;
}) {
  const copy = COPY[variant];
  return (
    <Alert
      severity="info"
      // A persistent notice: polite, so it is not re-announced as an alert on every page.
      role="status"
      sx={{ borderRadius: 0, alignItems: 'center' }}
      action={
        <Button
          component={RouterLink}
          to={to}
          color="inherit"
          size="small"
          variant="outlined"
          sx={{ whiteSpace: 'nowrap' }}
          onClick={onActionClick}
        >
          {copy.action}
        </Button>
      }
    >
      {copy.message}
    </Alert>
  );
}
